import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Activites from './Activites';
import Carousels from './Carousels';


const Home = () => {

  useEffect(() => {
    Aos.init({ duration: 900 })
  }, [])

  return (
    <div>
      <Carousels />
      <Container className='mt-5'>
        <Row>
          <Col md={7}>
            <h1>Welcome to</h1> <h1 style={{ color: '#f01f26' }}> Priyanka Memorial <br />International School</h1>
            <div className='d-flex mt-5' data-aos='fade-down'><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#ffbf00" className="bi bi-circle-fill" viewBox="0 0 16 16">
              <circle cx="8" cy="8" r="8" />
            </svg><h3> "Where Learning Meets <br /> Excellence"</h3>
            </div>
            <div className='d-flex mt-5' data-aos='fade-down'>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#de2511" className="bi bi-circle-fill" viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="8" />
              </svg><h3> Best Emerging School in Ghazipur</h3>
            </div>
            <div className='d-flex mt-5' data-aos='fade-down'>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#ffbf00" className="bi bi-circle-fill" viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="8" />
              </svg><h3>Quality Education are Provided in Rural areas</h3>
            </div>
            <div className='d-flex mt-5' data-aos='fade-down'>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#de2511" className="bi bi-circle-fill" viewBox="0 0 16 16">
                <circle cx="8" cy="8" r="8" />
              </svg><h3>Priyanka Memorial International  <br /> School is an CBSE Affiliated School <br /> in Ghazipur. </h3>
            </div>
          </Col>
          <Col md={5}>
            <div className="notice_boards ">
              <h4 className='text-center pb-2 m-0' style={{ borderBottom: '2px solid black' }}>Notice Boards</h4>
              <div className="text-container">
                <p className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> Mask is Compulsory for all Students.</p>
                <p style={{ color: '#ffbf00' }} className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> Submit Fee Before 15th of every month to avoid late fine.</p>
                <p className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> Maintain disipline in School.</p>
                <p style={{ color: '#ffbf00' }} className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> 75% Attendance is Mandatory</p>
                <p className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> Don't Damage School Property</p>
                <p style={{ color: '#ffbf00' }} className='mt-5 ms-3 '> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                </svg> Maintain Peace and Cleanliness in School</p>
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: '7rem' }}>
          <Col md={6}>
            <Row>
              <Col data-aos='flip-left' >
                <Image fluid src={require('../../Images/collage.jpg')} />
              </Col>
              <Col data-aos='flip-right' >
                <Image fluid src={require('../../Images/collage1.jpg')} />
              </Col>
            </Row>
          </Col>
          <Col md={6} data-aos='zoom-in'>
            <Image className='school_image' fluid src={require('../../Images/School Image.jpg')} />
          </Col>
        </Row>
        <Row className='mt-5 mb-5'>
          <Col  data-aos='flip-left' >
            <Image className='image_box' src={require('../../Images/Front (1).jpg')} />
          </Col>
          <Col data-aos='flip-right' >
            <Image className='image_box' src={require('../../Images/Front (2).jpg')} />
          </Col>
          <Col data-aos='flip-left' >
            <Image className='image_box' src={require('../../Images/Front (3).jpg')} />
          </Col>
          <Col  data-aos='flip-right' >
            <Image className='image_box' src={require('../../Images/Front (6).jpg')} />
          </Col>
          <Col data-aos='flip-left' >
            <Image className='image_box' src={require('../../Images/Front (5).jpg')} />
          </Col>
          <Col data-aos='flip-right' >
            <Image className='image_box' src={require('../../Images/Front (4).jpg')} />
          </Col>
        </Row>
        <hr />
      </Container>
      {/* 4 boxes */}
      <Container fluid>
        <Row className='d-flex justify-content-around mt-5 mb-5'>
          <Col  data-aos='zoom-in' md={2} className='content_Box' style={{ backgroundColor: '#211C84' }}>
            <div className="text-center mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-pen-fill" viewBox="0 0 16 16">
              <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001" />
            </svg></div>
            <h3 className='text-center mb-4' >Special Education</h3>
            <p className='p_justify_tag'>Priyanka Memorial International School Provides Modern Education as well as Developing Moral Values among Students to make him/her a perefect Citizen.</p>
          </Col>
          <Col data-aos='zoom-in'  md={2} className='content_Box' style={{ backgroundColor: '#FFAB5B' }} >
            <div className="text-center mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-journals" viewBox="0 0 16 16">
              <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2" />
              <path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0" />
            </svg></div>
            <h3 className='text-center mb-4' >Full Day Session</h3>
            <p className='p_justify_tag'>Our School Think about students for Whole day activity of students and assigns Homework and Assignment according to his/her Full Day program.</p>
          </Col>
          <Col  data-aos='zoom-in' md={2} className='content_Box' style={{ backgroundColor: '#009990' }} >
            <div className="text-center mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-person-fill" viewBox="0 0 16 16">
              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
            </svg></div>
            <h3 className='text-center mb-4' >Qualified Teachers</h3>
            <p className='p_justify_tag'>The Teachers of Priyanka Memorial International School are Highly Qualified and having a good Experience, to develop Quality among our Students.</p>
          </Col>
          <Col  data-aos='zoom-in' md={2} className='content_Box' style={{ backgroundColor: '#F95454' }} >
            <div className="text-center mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
              <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
              <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
            </svg></div>
            <h3 className='text-center mb-4' >Events</h3>
            <p className='p_justify_tag'>Priyanka Memorial International School Organizes Events and Functions and tries to participate each student to develop overall quality of students.</p>
          </Col>
        </Row>
      </Container>
      <Container>
        <hr />
        <Row className=' d-flex justify-content-evenly mt-5'>
          <h3 className='text-center mb-5' >Our Vision and Mission</h3>
          <Col md={5} className='vision_mission_box'>
            <h3 className='text-center mb-4' >Our Vision</h3>
            <p className='p_justify_tag fw-bold' >Priyanka Memorial International School is an English Medium School committed to the
              educational & spiritual traditions of the society.
              The purpose of education imparted in our school is not merely to prepare the students for
              examination but for the elevation of life itself. As we understand, education is not an end in
              itself, but rather a means to help a person to think and make decisions artlandbout ultimate
              values, one’s relationship with God, one’s personal goal and one’s commitment to others.
              Irrespective of one’s cast, creed and colour, everyone is given equal opportunity to be a
              beneficiary of this institution.
              Academic excellence, all round development, fostering of ethical and religious values and
              developing a sense of social responsibility are some of the characteristics of education
              imparted in the grand hall of the Priyanka Memorial International School.
              We have just started our journey and are now marching towards the future celebration.
              Persistence of service in the field of education is a big contribution to the society.</p>
          </Col>
          <Col md={5} className='vision_mission_box'>
            <h3 className='text-center mb-4' >Our Mission</h3>
            <p className='p_justify_tag fw-bold' >Education in the present day scenario plays a vital role in determining the standard of
              civilization of a particular country. Universal literacy is, therefore, the goal of every nation.
              Considering the importance of English, the accepted global motion and to keep pace with any
              other advanced countries of the world, the Priyanka Memorial International School evolves its
              policies to stress on high standard English teaching which pave the way to brilliant academic
              success. With this end in view, the institute endeavors to open schools in each and every
              district of the country so as to impart high quality education through English medium. In
              order to give education a wide coverage and to make it reach the youngsters at their earliest
              possible age, steps are taken to open Child Development Centres which would help in pre
              schooling and make children psychologically adapted to the process of learning through a
              novel technique of playful methods. With the rapid growth of population and consequent
              trend towards productive education, there is need for opening schools in a massive scale and
              run them effectively. According to statistical reviews, opening at least one school each day in
              the country cannot even suffice to meet the growing need.</p>
          </Col>
        </Row>
      </Container>
      <Activites />
      <Container fluid className=' mt-5 mb-5'>
        <Row className=' d-flex justify-content-around mt-5'>
          <h3 className='text-center mt-5 mb-5'>Our School Services</h3>
          <Col md={3} className='shadow_Box'>
            <div className="school_services">
              <div style={{ overflow: 'hidden' }}><Image className='Image_Hover' rounded fluid src={require('../../Images/other Services (2).jpg')} /></div>
              <h2 className='text-center'>Transportation</h2>
              <p className='text-center'>Our school provides transport facility for Students and Teachers.</p>
            </div>
          </Col>
          <Col md={3} className='shadow_Box' >
            <div className="school_services">
              <div style={{ overflow: 'hidden' }}><Image className='Image_Hover' rounded fluid src={require('../../Images/Computer Lab.jpg')} /></div>
              <h2 className='text-center'>Computer Education</h2>
              <p className='text-center'>Our school provides Computer learning to each students to develop IT skills among students.</p>
            </div>
          </Col>
          <Col md={3} className='shadow_Box'>
            <div className="school_services">
              <div style={{ overflow: 'hidden' }}> <Image className='Image_Hover' rounded fluid src={require('../../Images/Playground.jpg')} /></div>
              <h2 className='text-center'>Playground</h2>
              <p className='text-center'>We have a large playground for students physical development.</p>
            </div>
          </Col>
        </Row>
        <Row className=' d-flex justify-content-around mt-5' >
          <Col md={3} className='shadow_Box'>
            <div className="school_services">
              <div style={{ overflow: 'hidden' }}> <Image className='Image_Hover' rounded fluid src={require('../../Images/Smart Class.jpg')} /></div>
              <h2 className='text-center'>Digital Classroom</h2>
              <p className='text-center'>We have Digital Classroom to make studies more Interactive.</p>
            </div>
          </Col>
          <Col md={3} className='shadow_Box'>
            <div className="school_services">
              <div style={{ overflow: 'hidden' }}><Image className='Image_Hover' rounded fluid src={require('../../Images/Parent-Teachers-Interaction.jpg')} /></div>
              <h2 className='text-center'>Parent Teachers Interaction</h2>
              <p className='text-center'>We arrange Parent Teacher meeting for betterment of Student Future.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Home